import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { combineReducers } from 'redux';
import { isUndefinedNullOrEmpty } from '../utils';
import createNoOpReducer from './noOpReducerCreator';

const sourceReducer = (state = initialState.app.cloneCreation.source, action) => {
	switch(action.type) {
		case types.CLONE_SOURCE_SELECTED:
			return action.imageId;

	  default:
	      return state;
  }	
};

const destinationReducer = (state = initialState.app.cloneCreation.destination, action) => {
	switch(action.type) {
		case types.CLONE_DESTINATION_SELECTED:
			return action.destinationLocation;

	  default:
	      return state;
  }	
};

const operationReducer = (state = initialState.app.cloneCreation.operation, action) => {
	switch(action.type) {
		case types.CLONE_CREATION_UPDATED:
		const hasValue = !isUndefinedNullOrEmpty(action.value);
			return {
				status: action.updateStatus,
				id: hasValue && !isUndefinedNullOrEmpty(action.value.clone.latestOperation.id) ? action.value.clone.latestOperation.id : state.id,
				imageId: hasValue && !isUndefinedNullOrEmpty(action.value.clone) && !isUndefinedNullOrEmpty(action.value.clone.parentImageId) ? action.value.clone.parentImageId : state.imageId
			};

		default:
			return state;
	}
};

export default combineReducers({
	workflowStatus: createNoOpReducer(initialState.app.cloneCreation.workflowStatus),
	source: sourceReducer,
    destination: destinationReducer,
	operation: operationReducer
});


// WEBPACK FOOTER //
// ./src/js/reducers/cloneCreationReducer.js